import React from 'react';
import { Sparkles } from 'lucide-react';

// Subtle premium banner shown in the chat header when the user has an active
// subscription. Designed as a small inline badge — NOT a full banner that
// pushes the content down — to keep the chat real estate untouched.
//
// Visual: gold gradient pill with a sparkle icon. Sits next to the character
// name. On hover, expands slightly to show the expiry date (when available).
export default function PremiumBadge({ expiry, language = 'fr' }) {
  const label = {
    fr: 'Premium actif',
    en: 'Premium active',
    es: 'Premium activo',
    de: 'Premium aktiv',
    pt: 'Premium ativo',
  }[language] || 'Premium active';

  const formattedExpiry = formatExpiry(expiry, language);

  return (
    <div
      data-testid="premium-badge"
      title={formattedExpiry || undefined}
      className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-semibold uppercase tracking-wide shadow-sm"
      style={{
        background: 'linear-gradient(135deg, #D4A76A 0%, #C99A43 50%, #B8862E 100%)',
        color: '#FFFFFF',
        boxShadow: '0 2px 6px rgba(184,134,46,0.35)',
      }}
    >
      <Sparkles className="w-3 h-3" strokeWidth={2.4} />
      <span>{label}</span>
    </div>
  );
}

function formatExpiry(expiryIso, language) {
  if (!expiryIso) return null;
  try {
    const d = new Date(expiryIso);
    if (Number.isNaN(d.getTime())) return null;
    const localeMap = { fr: 'fr-FR', en: 'en-US', es: 'es-ES', de: 'de-DE', pt: 'pt-PT' };
    const dateStr = d.toLocaleDateString(localeMap[language] || 'en-US', {
      day: 'numeric', month: 'long', year: 'numeric',
    });
    const map = {
      fr: `Renouvellement le ${dateStr}`,
      en: `Renews on ${dateStr}`,
      es: `Renovación el ${dateStr}`,
      de: `Verlängerung am ${dateStr}`,
      pt: `Renovação a ${dateStr}`,
    };
    return map[language] || map.en;
  } catch {
    return null;
  }
}
